<template>
  <div id="wrapper" class="page" v-if="project_bonus_read">
    <!-- <contract-side-bar index="3" /> -->
    <div id="content-wrapper">
      <div class="container-fluid">
        <div>
          <b-row>
            <b-col cols="8">
              <button
                class="btn btn-info mb-2 mr-2"
                @click.prevent="openEmailModal(items)"
              >
                <i class="fas fa-envelope"></i> Send Email
              </button>
              <button
                class="btn btn-warning mb-2 mr-2"
                @click.prevent="openPayModal(items)"
              >
                <i class="fas fa-dollar-sign"></i> Pay
              </button>
              <button
                class="btn btn-success mb-2 mr-2"
                @click.prevent="openReportModal"
              >
                <i class="far fa-file-excel"></i> Report
              </button>
            </b-col>
          </b-row>
          <div style="flex-grow: 1" />
        </div>
        <b-row>
          <b-col cols="12">
            <div class="form-inline">
              <!-- <b-form-select v-model="status_selected" class="ml-3 mb-2 mr-2" style="width: 17%" :options="optionsStatus" value-field="value" text-field="text" @change="queryItem">
                <template #first>
                  <b-form-select-option value="0">All</b-form-select-option>
                </template>
              </b-form-select> -->
              <!-- <b-form-select v-if="status_selected!=0" v-model="year_selected" class="mb-2 mr-2" style="width: 7%" :options="optionsYear" value-field="value" text-field="text" @change="queryItem"> -->
              <b-form-select
                v-model="year_selected"
                class="mb-2 mr-2"
                style="width: 7%"
                :options="optionsYear"
                value-field="value"
                text-field="text"
                @change="queryItem"
              >
                <template #first>
                  <b-form-select-option value="0">Year</b-form-select-option>
                </template>
              </b-form-select>
              <!-- filter month when have a year -->
              <!-- <b-form-select v-if="year_selected!=0" v-model="month_selected" class="mb-2 mr-2" style="width: 10%" :options="optionsMonth" value-field="value" text-field="text" @change="queryItem"> -->
              <b-form-select
                v-model="month_selected"
                class="mb-2 mr-2"
                style="width: 7%"
                :options="optionsMonth"
                value-field="value"
                text-field="text"
                @change="queryItem"
              >
                <template #first>
                  <b-form-select-option value="0">Month</b-form-select-option>
                </template>
              </b-form-select>

              <b-form-select
                v-model="day_selected"
                class="mb-2 mr-2"
                style="width: 15%"
                :options="optionsDay"
                value-field="value"
                text-field="text"
                @change="queryItem"
              >
                <template #first>
                  <b-form-select-option value="0">Ngày ký</b-form-select-option>
                </template>
              </b-form-select>
              <b-form-input
                class="mb-2"
                style="flex-grow: 1"
                v-model="query"
                placeholder="Find Job"
                @keydown.enter.prevent="queryItem"
              >
              </b-form-input>
              <button class="btn" @click.prevent="queryItem">
                <i class="fas fa-search"></i>
              </button>
              <button class="btn" id="popover-target-1">
                <i class="fas fa-filter"></i>
              </button>
            </div>
          </b-col>
        </b-row>
        <b-popover target="popover-target-1" triggers="click blur">
          <template v-slot:title>Filters</template>
          <!-- <b-form-select
            v-model="status_selected"
            :options="optionsStatus"
            text-field = "text"
            value-field = "value"
            @change="queryItem"
          >
            <template v-slot:first>
              <b-form-select-option value="0"
                >All</b-form-select-option
              >
            </template>
          </b-form-select> -->
          <select
            style="font-size: 15px; font-family: arial"
            name="select"
            @change="queryItem"
            v-model="status_selected"
            id="rgb"
          >
            <option
              id="violet"
              value="0"
              style="font-size: 15px;font-family: arial; background-color: #FFEEFD"
              >All</option
            >
            <option
              id="orange"
              value="1"
              style="font-size: 15px;font-family: arial; background-color: #FFE1C6"
              >Unlock</option
            >
            <option
              id="yellow"
              value="2"
              style="font-size: 15px;font-family: arial; background-color: #FFFFD7"
              >Lock</option
            >
            <option
              id="blue"
              value="3"
              style="font-size: 15px;font-family: arial; background-color: #E2FCE6"
              >Send Email</option
            >
            <option
              id="blue"
              value="4"
              style="font-size: 15px;font-family: arial; background-color: #C0F7FE"
              >Paid</option
            >
            <option
              id="violet"
              value="5"
              style="font-size: 15px;font-family: arial; background-color: #B5B9FF"
              >UnPaid</option
            >
          </select>
        </b-popover>
        <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="fields"
          :items="items"
          selectable
          select-mode="single"
          @row-clicked="onRowClicked"
        >
          <!-- @row-selected="onRowSelected" -->
          <!-- Detail -->
          <template slot="row-details">
            <b-card v-if="this.employees.length > 0">
              <b-table
                bordered
                head-variant="dark"
                hover
                responsive
                striped
                small
                table-variant="light"
                :fields="employeeField"
                :items="employees"
              >
                <template #cell(STT)="data">
                  {{ data.index + 1 }}
                </template>
                <template v-slot:cell(sotien)="data">
                  {{
                    data.item.employeecontractbonusid == null
                      ? ""
                      : findBonusMoney(
                          employeecontractbonuses,
                          data.item.employeecontractbonusid
                        ) | numeral("0,0")
                  }}
                </template>
                <template v-slot:cell(currency)="data">
                  {{
                    data.item.employeecontractbonusid == null
                      ? ""
                      : findCurrency(
                          employeecontractbonuses,
                          data.item.employeecontractbonusid
                        )
                  }}
                </template>
                <!-- <template v-slot:cell(exchangeRate)="data">{{
                                  data.item.customercontractid == null
                                    ? ""
                                    : findExchangeRate(items, data.item.customercontractid)
                                      | numeral("0,0")
                                }}</template> -->
                <template v-slot:cell(exchangeRate)="data">
                  <span
                    v-if="
                      findExchangeRate2(
                        employeecontractbonuses,
                        data.item.employeecontractbonusid,
                        items,
                        data.item.customercontractid
                      )
                    "
                  >
                    {{
                      data.item.employeecontractbonusid == null
                        ? ""
                        : findExchangeRate2(
                            employeecontractbonuses,
                            data.item.employeecontractbonusid,
                            items,
                            data.item.customercontractid
                          ) | numeral("0,0")
                    }}
                  </span>
                </template>
                <template v-slot:cell(vitri)="data">
                  {{
                    data.item.employeecontractbonusid == null
                      ? ""
                      : findBonusPosition(
                          employeecontractbonuses,
                          data.item.employeecontractbonusid
                        )
                  }}
                </template>
                <template v-slot:cell(vitricongviec)="data">
                  {{
                    data.item.vitricongviec == null
                      ? ""
                      : findPickList(vitricongviecs, data.item.vitricongviec)
                  }}
                </template>
                <template v-slot:cell(donvicongtac)="data">
                  {{
                    data.item.donvicongtac == null
                      ? ""
                      : findFirstDepartment(departments, data.item.donvicongtac)
                  }}
                </template>

                <template v-slot:cell(sotienthanhtoan)="data">
                  {{ data.item.sotienthanhtoan | numeral("0,0") }}
                </template>
                <template v-slot:cell(sendmail)="data">
                  <span class="text-success" v-if="data.item.sendmail != null">
                    <i class="fas fa-check"></i>
                  </span>
                </template>
                <template slot="bottom-row">
                  <td style="text-align:center" colspan="5"><b>TOTAL</b></td>
                  <td style="text-align:right">
                    <b>{{ sum_point }}</b>
                  </td>
                  <td style="text-align:right" colspan="4">
                    <b>{{ sum_total | numeral("0,0") }}</b>
                  </td>
                  <td style="text-align:center" colspan="2"></td>
                </template>
              </b-table>
            </b-card>
          </template>
          <!-- Custom Header -->
          <template v-slot:head(selected)="">
            <b-form-checkbox v-model="selectAll"> </b-form-checkbox>
          </template>

          <template v-slot:cell(selected)="data">
            <b-form-checkbox v-model="data.item.selected"> </b-form-checkbox>
          </template>

          <template v-slot:cell(test)="data">
            {{ data.item.selected }} - {{ data.item.id }}
          </template>

          <template #cell(tieude)="data">
            <strong>{{ data.value }}</strong>
          </template>

          <template #cell(STT)="data">{{ data.index + 1 }}</template>
          <!-- <template v-slot:cell(thangbatdau)="data">{{data.item.ngaybatdau | moment('MM/YYYY')}}</template> -->
          <template v-slot:cell(ngaybatdau)="data">{{
            data.item.ngaybatdau | moment("DD/MM/YYYY")
          }}</template>
          <template v-slot:cell(departmentid)="data">{{
            data.item.departmentid == null
              ? ""
              : findFirstDepartment(departments, data.item.departmentid)
          }}</template>
          <!-- <template v-slot:cell(tinhtrang)="data">{{
            data.item.tinhtrang == null
              ? ""
              : findPickList(tinhtranghopdongs, data.item.tinhtrang)
          }}</template> -->
          <template v-slot:cell(tinhtrang)="data">
            <b-badge variant="default" v-if="data.item.tinhtrang == null">
            </b-badge>
            <b-badge variant="danger" v-else-if="data.item.tinhtrang == 50">
              {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
            </b-badge>
            <b-badge variant="danger2" v-else-if="data.item.tinhtrang == 51">
              {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
            </b-badge>
            <b-badge variant="warning" v-else-if="data.item.tinhtrang == 52">
              {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
            </b-badge>
            <b-badge variant="info" v-else-if="data.item.tinhtrang == 53">
              {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
            </b-badge>
            <b-badge
              variant="primary"
              v-else-if="data.item.tinhtrang > 53 && data.item.tinhtrang <= 146"
            >
              {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
            </b-badge>
            <b-badge variant="success" v-else-if="data.item.tinhtrang > 146">
              {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
            </b-badge>
          </template>
          <!-- <template v-slot:cell(giatriduocnghiemthu)="data">
            <span v-if="data.item.giatriduocnghiemthu">
              {{ data.item.giatriduocnghiemthu | numeral("0,0") }}
            </span>
          </template> -->
          <template v-slot:cell(duan_revenue)="data">
            <span v-if="data.item.duan_revenue">
              {{ data.item.duan_revenue | numeral("0,0") }}
            </span>
          </template>
          <template v-slot:cell(chiphi)="data">
            <span v-if="data.item.chiphi">
              {{ data.item.chiphi | numeral("0,0") }}
            </span>
          </template>
          <!-- <template v-slot:cell(loinhuan)="data">
            <span v-if = "(data.item.giatriduocnghiemthu - data.item.chiphi)!=0">
              {{ (data.item.giatriduocnghiemthu - data.item.chiphi) | numeral("0,0") }}
            </span>
          </template> -->
          <template v-slot:cell(loinhuan)="data">
            <span v-if="data.item.duan_revenue - data.item.chiphi != 0">
              {{ (data.item.duan_revenue - data.item.chiphi) | numeral("0,0") }}
            </span>
          </template>
          <template v-slot:cell(duan_tylethuong)="data">
            <span v-if="data.item.duan_tylethuong">
              {{ data.item.duan_tylethuong | numeral("0,0") }}%
            </span>
          </template>
          <template v-slot:cell(duan_bonus)="data">
            <span v-if="data.item.duan_bonus"
              ><strong>{{ data.item.duan_bonus | numeral("0,0") }}</strong>
            </span>
          </template>

          <template v-slot:cell(duan_lock)="data">
            <span v-if="!data.item.duan_lock">
              <i class="fas fa-unlock-alt"></i>
            </span>
            <span v-else-if="!data.item.duan_ngaythanhtoan">
              <i class="fas fa-lock" style="color:green"></i>
            </span>
            <span v-else>
              <i class="fas fa-dollar-sign" style="color:brown"></i>
            </span>
          </template>
          <template v-slot:cell(duan_sendmail)="data">
            <span
              class="text-success"
              v-if="
                data.item.duan_sendmail != null && check_if_sent(data.item.id)
              "
            >
              <i class="fas fa-envelope"></i>
            </span>
            <span
              class="text-warning"
              v-if="
                data.item.duan_sendmail != null && !check_if_sent(data.item.id)
              "
            >
              <i class="fas fa-reply-all"></i>
            </span>
          </template>

          <!-- <template v-slot:cell(duan_paid)="data">
            <span v-if="data.item.duan_ngaythanhtoan != null">
              <i class="fas fa-dollar-sign"></i>
            </span>
          </template> -->

          <template v-slot:cell(action)="data">
            <b-link
              class="text-primary"
              href="#"
              @click.prevent="addEmployeeToProject(data)"
            >
              <!-- <i class="fas fa-plus"></i> -->
              <i class="fas fa-pencil-alt"></i>
            </b-link>
          </template>

          <template slot="bottom-row">
            <td style="text-align:center" colspan="5"><b>TOTAL</b></td>
            <td style="text-align:right">
              <span v-if="sum_revenue">
                <b>{{ sum_revenue | numeral("0,0") }}</b>
              </span>
            </td>
            <td style="text-align:right">
              <span v-if="sum_cost">
                <b>{{ sum_cost | numeral("0,0") }}</b>
              </span>
            </td>
            <td style="text-align:right">
              <span v-if="sum_profit">
                <b>{{ sum_profit | numeral("0,0") }}</b>
              </span>
            </td>
            <td style="text-align:right" colspan="2">
              <span v-if="sum_bonus">
                <b>{{ sum_bonus | numeral("0,0") }}</b>
              </span>
            </td>
          </template>
        </b-table>

        <b-row style="width: 100%;">
          <b-col cols="12">
            <b-card
              no-body
              v-if="employees.length != 0 && selected.length > 0"
              style="width: 100%"
            >
              <b-table
                bordered
                head-variant="dark"
                hover
                responsive
                striped
                small
                table-variant="light"
                :fields="employeeField"
                :items="employees"
              >
                <template #cell(STT)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(sotien)="data"
                  >{{
                    data.item.employeecontractbonusid == null
                      ? ""
                      : findBonusMoney(
                          employeecontractbonuses,
                          data.item.employeecontractbonusid
                        ) | numeral("0,0")
                  }}
                </template>
                <template v-slot:cell(currency)="data"
                  >{{
                    data.item.employeecontractbonusid == null
                      ? ""
                      : findCurrency(
                          employeecontractbonuses,
                          data.item.employeecontractbonusid
                        )
                  }}
                </template>
                <!-- <template v-slot:cell(exchangeRate)="data">{{
                  data.item.customercontractid == null
                    ? ""
                    : findExchangeRate(items, data.item.customercontractid)
                      | numeral("0,0")
                }}</template> -->
                <template v-slot:cell(exchangeRate)="data">
                  <span
                    v-if="
                      findExchangeRate2(
                        employeecontractbonuses,
                        data.item.employeecontractbonusid,
                        items,
                        data.item.customercontractid
                      )
                    "
                  >
                    {{
                      data.item.employeecontractbonusid == null
                        ? ""
                        : findExchangeRate2(
                            employeecontractbonuses,
                            data.item.employeecontractbonusid,
                            items,
                            data.item.customercontractid
                          ) | numeral("0,0")
                    }}
                  </span>
                </template>
                <template v-slot:cell(vitri)="data">{{
                  data.item.employeecontractbonusid == null
                    ? ""
                    : findBonusPosition(
                        employeecontractbonuses,
                        data.item.employeecontractbonusid
                      )
                }}</template>
                <template v-slot:cell(vitricongviec)="data">{{
                  data.item.vitricongviec == null
                    ? ""
                    : findPickList(vitricongviecs, data.item.vitricongviec)
                }}</template>
                <template v-slot:cell(donvicongtac)="data">{{
                  data.item.donvicongtac == null
                    ? ""
                    : findFirstDepartment(departments, data.item.donvicongtac)
                }}</template>

                <template v-slot:cell(sotienthanhtoan)="data"
                  >{{ data.item.sotienthanhtoan | numeral("0,0") }}
                </template>
                <template v-slot:cell(sendmail)="data">
                  <span class="text-success" v-if="data.item.sendmail != null">
                    <i class="fas fa-check"></i>
                  </span>
                </template>
                <!-- <template v-slot:cell(action)="data">
                    <b-link class="text-primary" href="#" @click.prevent="openEmployeeModal(data)">
                      <i class="fas fa-pencil-alt"></i>
                    </b-link>
                  </template> -->
              </b-table>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- Send Email modal -->
      <div>
        <b-modal
          v-model="emailModalShow"
          header-bg-variant="info"
          header-text-variant="light"
          @hidden="closeEmailModal"
          style="white-space: pre-wrap;"
          size="xl"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          hide-footer
          :disabled="isLoading"
        >
          <template #modal-title>
            <div>Information</div>
          </template>
          <b-overlay :show="isLoading" rounded="sm">
            <b-form class="mr-4" autocomplete="off" @submit="ok()">
              <b-container>
                <b-form-row class="mb-4">
                  <b-col cols="1"> </b-col>
                  <b-col cols="2">
                    <label class="mr-2">Email:</label>
                    <code>*</code>
                  </b-col>

                  <b-col cols="7">
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        name="email"
                        v-model="email"
                        autocomplete="off"
                        required
                      />
                    </div>
                  </b-col>
                </b-form-row>

                <b-row class="mb-4">
                  <b-col cols="1"> </b-col>

                  <b-col cols="2">
                    <label class="mr-2">Password:</label>
                    <code>*</code>
                  </b-col>

                  <b-col cols="7">
                    <div class="col-sm-8">
                      <input
                        type="password"
                        class="form-control"
                        name="password"
                        v-model="password"
                        autocomplete="off"
                        required
                      />
                    </div>
                  </b-col>
                </b-row>

                <b-form-row class="mb-3">
                  <b-col cols="12" class="form-inline">
                    <div style="flex-grow: 1"></div>
                    <b-button
                      class="mr-3"
                      variant="info"
                      @click.prevent="sendEmailToProject(sendEmailItems)"
                    >
                      <i class="fas fa-envelope mr-2"></i>Send
                    </b-button>
                    <b-button variant="secondary" @click="closeEmailModal">
                      <i class="fas fa-times mr-2"></i>Close
                    </b-button>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-table
                    bordered
                    head-variant="dark"
                    hover
                    responsive
                    striped
                    small
                    table-variant="light"
                    :fields="sendEmailFields"
                    :items="sendEmailItems"
                  >
                    <template #cell(STT)="data">
                      {{ data.index + 1 }}
                    </template>
                    <!-- <template v-slot:cell(thangbatdau)="data">{{data.item.ngaybatdau | moment('MM/YYYY')}}</template> -->
                    <template v-slot:cell(ngaybatdau)="data">
                      {{ data.item.ngaybatdau | moment("DD/MM/YYYY") }}
                    </template>
                    <template v-slot:cell(departmentid)="data">
                      {{
                        data.item.departmentid == null
                          ? ""
                          : findFirstDepartment(
                              departments,
                              data.item.departmentid
                            )
                      }}
                    </template>
                    <template v-slot:cell(tinhtrang)="data">
                      {{
                        data.item.tinhtrang == null
                          ? ""
                          : findPickList(tinhtranghopdongs, data.item.tinhtrang)
                      }}
                    </template>
                    <template v-slot:cell(duan_bonus)="data">
                      <span v-if="data.item.duan_bonus">
                        {{ data.item.duan_bonus | numeral("0,0") }}
                      </span>
                    </template>

                    <!-- <template v-slot:cell(duan_lock)="data">
                                          <span v-if="!data.item.duan_ngaythanhtoan">
                                            <span v-if="data.value">
                                              <i class="fas fa-lock" style="color:green"></i>
                                            </span>
                                            <span v-else>
                                              <i class="fas fa-unlock-alt"></i>
                                            </span>
                                          </span>
                                          <span v-else>
                                            <i class="fas fa-dollar-sign" style="color:brown"></i>
                                          </span>
                                        </template> -->
                    <template v-slot:cell(duan_lock)="data">
                      <span v-if="data.value">
                        <i class="fas fa-lock" style="color:green"></i>
                      </span>
                      <span v-else>
                        <i class="fas fa-unlock-alt"></i>
                      </span>
                    </template>

                    <template v-slot:cell(duan_sendmail)="data">
                      <span
                        class="text-success"
                        v-if="data.item.duan_sendmail != null"
                      >
                        <i class="fas fa-check"></i>
                      </span>
                    </template>
                    <template v-slot:cell(duan_ngaythanhtoan)="data">
                      <span
                        class="text-success"
                        v-if="data.item.duan_ngaythanhtoan != null"
                      >
                        <i class="fas fa-dollar-sign" style="color:brown"></i>
                      </span>
                    </template>
                  </b-table>
                </b-form-row>
              </b-container>
            </b-form>

            <template #overlay>
              <div class="text-center">
                <!-- <b-icon icon="fas fa-spinner fa-spin" font-scale="4" animation="cylon"></b-icon> -->
                <div class="fa-4x">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
                <p>Sending ...</p>
                <!-- <b-button
                                  ref="cancel"
                                  variant="outline-danger"
                                  size="sm"
                                  aria-describedby="cancel-label"
                                  @click="show = false"
                                >
                                  Cancel
                                </b-button> -->
              </div>
            </template>
          </b-overlay>
        </b-modal>
      </div>
      <!-- end of send email modal -->
      <!-- Pay modal -->
      <div>
        <b-modal
          v-model="payModalShow"
          header-bg-variant="info"
          header-text-variant="light"
          @hidden="closePayModal"
          style="white-space: pre-wrap;"
          size="xl"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          hide-footer
          :disabled="isLoading"
        >
          <template #modal-title>
            <div>Pay Information</div>
          </template>
          <b-overlay :show="isLoading" rounded="sm">
            <b-form class="mr-4" autocomplete="off" @submit="ok()">
              <b-container>
                <b-form-row class="mb-4">
                  <b-col cols="3"> </b-col>
                  <b-col cols="2">
                    <label class="mr-2">Paid Date:</label>
                    <code>*</code>
                  </b-col>

                  <b-col cols="3">
                    <div class="col-sm-9">
                      <!-- <vue-datepicker-local
                                              style="width: 100%"
                                              v-model="pay_ngaythanhtoan"
                                              :local="local"
                                              clearable
                                              format="DD/MM/YYYY"
                                            /> -->
                      <my-date-picker
                        v-model="pay_ngaythanhtoan"
                        :required="true"
                      ></my-date-picker>
                    </div>
                  </b-col>

                  <b-col class="form-inline">
                    <div style="flex-grow: 1"></div>
                    <b-button
                      class="mr-3"
                      variant="info"
                      @click.prevent="payProject(payItems)"
                    >
                      <i class="fas fa-dollar-sign mr-2"></i>Pay
                    </b-button>
                    <b-button variant="secondary" @click="closePayModal">
                      <i class="fas fa-times mr-2"></i>Close
                    </b-button>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-table
                    bordered
                    head-variant="dark"
                    hover
                    responsive
                    striped
                    small
                    table-variant="light"
                    :fields="payFields"
                    :items="payItems"
                  >
                    <template #cell(STT)="data">
                      {{ data.index + 1 }}
                    </template>
                    <!-- <template v-slot:cell(thangbatdau)="data">{{data.item.ngaybatdau | moment('MM/YYYY')}}</template> -->
                    <template v-slot:cell(ngaybatdau)="data">
                      {{ data.item.ngaybatdau | moment("DD/MM/YYYY") }}
                    </template>
                    <template v-slot:cell(departmentid)="data">
                      {{
                        data.item.departmentid == null
                          ? ""
                          : findFirstDepartment(
                              departments,
                              data.item.departmentid
                            )
                      }}
                    </template>
                    <template v-slot:cell(tinhtrang)="data">
                      {{
                        data.item.tinhtrang == null
                          ? ""
                          : findPickList(tinhtranghopdongs, data.item.tinhtrang)
                      }}
                    </template>
                    <template v-slot:cell(duan_bonus)="data">
                      <span v-if="data.item.duan_bonus">
                        {{ data.item.duan_bonus | numeral("0,0") }}
                      </span>
                    </template>

                    <template v-slot:cell(duan_lock)="data">
                      <span v-if="data.value">
                        <i class="fas fa-lock" style="color:green"></i>
                      </span>
                      <span v-else>
                        <i class="fas fa-unlock-alt"></i>
                      </span>
                    </template>

                    <template v-slot:cell(duan_sendmail)="data">
                      <span
                        class="text-success"
                        v-if="data.item.duan_sendmail != null"
                      >
                        <i class="fas fa-check"></i>
                      </span>
                    </template>
                    <template v-slot:cell(duan_ngaythanhtoan)="data">
                      <span
                        class="text-success"
                        v-if="data.item.duan_ngaythanhtoan != null"
                      >
                        <i class="fas fa-dollar-sign" style="color:brown"></i>
                      </span>
                    </template>
                  </b-table>
                </b-form-row>
              </b-container>
            </b-form>

            <template #overlay>
              <div class="text-center">
                <!-- <b-icon icon="fas fa-spinner fa-spin" font-scale="4" animation="cylon"></b-icon> -->
                <div class="fa-4x">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
                <p>Paying ...</p>
                <!-- <b-button
                                  ref="cancel"
                                  variant="outline-danger"
                                  size="sm"
                                  aria-describedby="cancel-label"
                                  @click="show = false"
                                >
                                  Cancel
                                </b-button> -->
              </div>
            </template>
          </b-overlay>
        </b-modal>
      </div>
      <!-- end of Pay modal -->
      <!-- EMPLOYEE MODAL -->
      <div>
        <b-modal
          v-model="employeeModalShow"
          header-bg-variant="info"
          header-text-variant="light"
          size="xl"
          @hidden="closeEmployeeModal"
          hide-footer
        >
          <template v-slot:modal-title>
            <div>Project Information</div>
          </template>
          <b-container>
            <form @submit.prevent="updateEmployeeProject" autocomplete="off">
              <b-row class="mb-4">
                <b-col cols="2">
                  <label class="mr-2">Tên nhân viên</label>
                </b-col>
                <b-col cols="9">
                  <b-form-input v-model="employee_name" readonly></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col cols="2">
                  <label class="mr-2">Tên dự án</label>
                </b-col>
                <b-col cols="9">
                  <b-form-input v-model="project_name" readonly></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col cols="2">
                  <label class="mr-2">Vai trò</label>
                </b-col>
                <b-col cols="3">
                  <b-form-select
                    v-model="projectItem.vaitrotrongduan"
                    :options="vaitrotrongduans"
                    value-field="id"
                    text-field="pickListValue"
                  />
                </b-col>
                <b-col cols="2">
                  <label class="mr-2">Số tiền</label>
                </b-col>
                <b-col cols="3">
                  <my-currency-input
                    v-model="projectItem.sotienthanhtoan"
                  ></my-currency-input>
                </b-col>
                <b-col>
                  <button class="btn btn-info" type="submit">
                    <i class="fas fa-save"></i> Lưu
                  </button>
                </b-col>
              </b-row>
            </form>
          </b-container>
        </b-modal>
      </div>
      <!-- END OF EMPLOYEE MODAL -->
      <!-- <multiselect></multiselect> -->
      <!-- REPORT MODAL -->
      <b-modal
        v-model="reportModalShow"
        header-bg-variant="primary"
        header-text-variant="light"
        hide-footer
        @hidden="closeReportModal"
        title="MẪU BÁO CÁO"
        text-center
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
        <b-form autocomplete="false">
          <!-- 1. Ten loai bao cao -->
          <b-row>
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Loại báo cáo</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-select v-model="reportKind" @change="changeReportKind">
                  <!-- Ten Mau 01 = value mau 3 trong phan quyen -->
                  <b-form-select-option
                    value="3"
                    v-if="project_report3 || project_report_all"
                  >
                    Mẫu 01 - Báo cáo Bonus theo nhân viên
                  </b-form-select-option>

                  <b-form-select-option
                    value="5"
                    v-if="project_report5 || project_report_all"
                  >
                    Mẫu 02 - Báo cáo Bonus tổng hợp
                  </b-form-select-option>
                  <b-form-select-option
                    value="6"
                    v-if="project_report6 || project_report_all"
                  >
                    Mẫu 03 - Báo cáo Bonus dịch vụ sản xuất
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- 2. Ten option bao cao -->
          <!-- #region Report 1 (Khong su dung)-->
          <b-row v-if="reportKind == 1">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b> Tên khách hàng </b>
                  <span class="text-danger">*</span>
                </template>
                <!-- <multiselect
                                  v-model="customer"
                                  placeholder
                                  track-by="id"
                                  label="ten"
                                  selectedLabel="Đang chọn"
                                  select-label="Enter để chọn"
                                  deselectLabel="Enter để xóa"
                                  :searchable="true"
                                  :options="customers"
                                  :taggable="true"
                                  :multiple="false"
                                ></multiselect> -->

                <b-form-select
                  v-model="customer"
                  :options="customers"
                  value-field="id"
                  text-field="ten"
                >
                  <template #first>
                    <b-form-select-option :value="null">
                      Tất cả
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- #endregion -->
          <!-- #region Report 3 : BAO CAO BONUS THEO NHAN VIEN-->
          <b-row v-if="reportKind == 3">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Kỳ báo cáo</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-select
                  v-model="kyBaoCao_Report3"
                  :options="optionsKyBaoCao_Report3"
                  @change="changeKyBaoCao_Report3"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 3">
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Từ ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="fromDateReport3"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Đến ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="toDateReport3"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 3">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  Vai trò
                </template>
                <multiselect
                  v-model="vitris_selected"
                  placeholder
                  track-by="id"
                  label="pickListValue"
                  selectedLabel="Đang chọn"
                  select-label="Enter để chọn"
                  deselectLabel="Enter để xóa"
                  :searchable="true"
                  :multiple="true"
                  :options="vitricongviecs"
                  @input="filterEmployee"
                ></multiselect>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 3">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  Nhân viên
                  <!-- <span class="text-danger">*</span> -->
                </template>
                <!-- <multiselect
                                  v-model="employeeid_selected"
                                  placeholder
                                  track-by="id"
                                  label="mahovaten"
                                  selectedLabel="Đang chọn"
                                  select-label="Enter để chọn"
                                  deselectLabel="Enter để xóa"
                                  :searchable="true"
                                  :options="employees"
                                  :value ="employeeid_selected">
                                </multiselect> -->
                <multiselect
                  v-model="employees_selected"
                  placeholder
                  track-by="id"
                  label="hovaten"
                  selectedLabel="Đang chọn"
                  select-label="Enter để chọn"
                  deselectLabel="Enter để xóa"
                  :searchable="true"
                  :multiple="true"
                  :options="Employee_List"
                ></multiselect>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- #endregion -->
          <!-- #region Report 5 : BAO CAO BONUS TONG HOP-->
          <b-row v-if="reportKind == 5">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Kỳ báo cáo</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-select
                  v-model="kyBaoCao_Report5"
                  :options="optionsKyBaoCao_Report5"
                  @change="changeKyBaoCao_Report5"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 5">
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Từ ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="fromDateReport5"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Đến ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="toDateReport5"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 5">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Note</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-checkbox v-model="note_employee"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- #endregion -->
          <!-- #region Report 6 : BÁO CÁO TIỀN THƯỞNG DỊCH VỤ SẢN XUẤT-->
          <b-row v-if="reportKind == 6">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Kỳ báo cáo</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-select
                  v-model="kyBaoCao_Report6"
                  :options="optionsKyBaoCao_Report6"
                  @change="changeKyBaoCao_Report6"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 6">
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Từ ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="fromDateReport6"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Đến ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="toDateReport6"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- <b-row v-if="reportKind == 6">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Note</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-checkbox v-model="note_employee"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row> -->
          <!-- #endregion -->

          <!-- 3. Button Select -->
          <b-row>
            <b-col>
              <b-form-group>
                <b-button
                  class="mr-2"
                  variant="info"
                  @click.prevent="exportExcel"
                >
                  <i class="fas fa-file-excel mr-2"></i>
                  Export to Excel
                  <!-- Xuất Excel -->
                </b-button>
                <b-button
                  class="mr-2"
                  variant="secondary"
                  @click.prevent="closeReportModal"
                >
                  <i class="fas fa-times mr-2"></i>
                  Close
                  <!-- Đóng -->
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <!-- END OF REPORT MODAL -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import ContractSideBar from "../components/Contract/ContractSideBar";
import MyCurrencyInput from "../components/App/MyCurrencyInput.vue";
// import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyDatePicker from "../components/App/MyDatePicker";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";

export default {
  name: "Contracts",
  components: {
    //ContractSideBar,
    MyCurrencyInput,
    VueDatepickerLocal,
    MyDatePicker,
    Multiselect,
  },
  data() {
    return {
      fields: [
        //Checkbox
        {
          key: "selected",
          label: "",
          thClass: "align-middle",
          thStyle: { width: "10px", textAlign: "center" },
        },
        {
          key: "STT",
          label: "#",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "tieude",
          label: "Job",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "400px", textAlign: "center" },
        },
        // {
        //   // @Edit Thanh A virtual column with custom formatter
        //   key: "thangbatdau",
        //   label: "Month",
        //   // sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "100px", textAlign: "center" },
        //   formatter: (value, key, item) => {
        //     if (!item.ngaybatdau) return "";
        //     return this.$moment(item.ngaybatdau).format("MM/YYYY");
        //   },
        // },
        {
          key: "ngaybatdau",
          label: "Shooting Date",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "tinhtrang",
          label: "Status",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "300px", textAlign: "center" },
        },
        // {
        //   key: "giatriduocnghiemthu",
        //   label: "Revenue",
        //   // sortable: true,
        //   tdClass: "text-right",
        //   thClass: "align-middle",
        //   thStyle: { width: "130px !important", textAlign: "center" },
        // },
        {
          key: "duan_revenue",
          label: "Revenue",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "130px !important", textAlign: "center" },
        },
        {
          key: "chiphi",
          label: "Cost",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "130px !important", textAlign: "center" },
        },
        {
          key: "loinhuan",
          label: "Profit",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "130px !important", textAlign: "center" },
          // formatter: (value, key, item) => {
          //   // if (item.giatriduocnghiemthu == 0 || item.chiphi == 0) return "";
          //   return item.giatriduocnghiemthu;
          // },
        },
        {
          key: "duan_tylethuong",
          label: "Rate of profit",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "100px !important", textAlign: "center" },
        },
        {
          key: "duan_bonus",
          label: "Bonus",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "130px !important", textAlign: "center" },
        },
        // {
        //   key: "departmentid",
        //   label: "Production",
        //   sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "120px", textAlign: "center" },
        // },
        // {
        //   key: "duan_note",
        //   label: "Note",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: { textAlign: "center" },
        // },
        {
          key: "duan_lock",
          label: "Status",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
        {
          key: "duan_sendmail",
          label: "Email",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
        // {
        //   key: "duan_paid",
        //   label: "Paid",
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "25px !important", textAlign: "center" },
        // },
        // {
        //   key: "duan_ngaythanhtoan",
        //   label: "Paid",
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "25px !important", textAlign: "center" },
        // },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
      ],
      selectAll: false, // uncheckbox all on header
      selectedReal: [],

      employeeField: [
        {
          key: "STT",
          label: "#",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "manhanvien",
          label: "Code",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "hovaten",
          label: "Name",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "280px", textAlign: "center" },
        },
        {
          key: "donvicongtac",
          label: "Company",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "vitri",
          label: "Position",
          // sortable: true,
          thClass: "align-middle",
          thStyle: { width: "180px", textAlign: "center" },
        },
        {
          key: "diem",
          label: "Point",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "70px", textAlign: "center" },
        },
        {
          key: "sotien",
          label: "Bonus Rate",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "currency",
          label: "Currency",
          // sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
        },
        {
          key: "exchangeRate",
          label: "Exchange Rate",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "sotienthanhtoan",
          label: "Total Received",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "note",
          label: "Note",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "sendmail",
          label: "Email",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "50px", textAlign: "center" },
        },
      ],
      //filter
      query: null,
      year_selected: -1,
      month_selected: 0,
      status_selected: 0,
      day_selected: 0, // ngay du kien thanh toan
      note_employee: 0,
      optionsMonth: [
        { value: 1, text: "Tháng 1" },
        { value: 2, text: "Tháng 2" },
        { value: 3, text: "Tháng 3" },
        { value: 4, text: "Tháng 4" },
        { value: 5, text: "Tháng 5" },
        { value: 6, text: "Tháng 6" },
        { value: 7, text: "Tháng 7" },
        { value: 8, text: "Tháng 8" },
        { value: 9, text: "Tháng 9" },
        { value: 10, text: "Tháng 10" },
        { value: 11, text: "Tháng 11" },
        { value: 12, text: "Tháng 12" },
        { value: 13, text: "Quý I" },
        { value: 14, text: "Quý II" },
        { value: 15, text: "Quý III" },
        { value: 16, text: "Quý IV" },
      ],

      optionsDay: [{ value: 1, text: "Ngày dự kiến thanh toán" }],

      optionsStatus: [
        { value: 1, text: "Shooting Date" },
        { value: 2, text: "Send Email - Filter by Lock Date" },
        { value: 3, text: "Pay - Filter by Lock Date & Email" },
        { value: 4, text: "Lock Date" },
        { value: 5, text: "Paid" },
      ],

      items: [],
      departments: [],
      tinhtranghopdongs: [],
      tinhtranghosos: [],
      vitricongviecs: [],
      vaitrotrongduans: [],
      employees: [],
      employeecontractbonuses: [],

      //Send email
      emailModalShow: false,
      email: null,
      password: null,
      sendEmailItems: [],
      sendEmailFields: [
        //Checkbox
        // {
        //   key: "selected",
        //   label: "",
        //   thClass: "align-middle",
        //   thStyle: { width: "10px", textAlign: "center" },
        // },
        {
          key: "STT",
          label: "#",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "tieude",
          label: "Job",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          // A virtual column with custom formatter
          key: "thangbatdau",
          label: "Month",
          // sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (!item.ngaybatdau) return "";
            return this.$moment(item.ngaybatdau).format("MM/YYYY");
          },
        },
        {
          key: "ngaybatdau",
          label: "Shooting Date",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "tinhtrang",
          label: "Status",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "200px", textAlign: "center" },
        },
        {
          key: "duan_bonus",
          label: "Total Bonus",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "150px !important", textAlign: "center" },
        },
        {
          key: "departmentid",
          label: "Production",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        // {
        //   key: "duan_note",
        //   label: "Note",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: { textAlign: "center" },
        // },
        {
          key: "duan_lock",
          label: "Status",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
        {
          key: "duan_sendmail",
          label: "Email",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
        {
          key: "duan_ngaythanhtoan",
          label: "Paid",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
        // {
        //   key: "action",
        //   label: "",
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "25px !important", textAlign: "center" },
        // },
      ],
      isLoading: false,

      //Pay modal
      payModalShow: false,
      pay_ngaythanhtoan: this.$convert_date_string(new Date()),
      payItems: [],
      payFields: [
        //Checkbox
        // {
        //   key: "selected",
        //   label: "",
        //   thClass: "align-middle",
        //   thStyle: { width: "10px", textAlign: "center" },
        // },
        {
          key: "STT",
          label: "#",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "tieude",
          label: "Job",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          // A virtual column with custom formatter
          key: "thangbatdau",
          label: "Month",
          // sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (!item.ngaybatdau) return "";
            return this.$moment(item.ngaybatdau).format("MM/YYYY");
          },
        },
        {
          key: "ngaybatdau",
          label: "Shooting Date",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "tinhtrang",
          label: "Status",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "200px", textAlign: "center" },
        },

        {
          key: "duan_bonus",
          label: "Total Bonus",
          // sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "150px !important", textAlign: "center" },
        },
        {
          key: "departmentid",
          label: "Production",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        // {
        //   key: "duan_note",
        //   label: "Note",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: { textAlign: "center" },
        // },
        {
          key: "duan_lock",
          label: "Status",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
        {
          key: "duan_sendmail",
          label: "Email",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
        {
          key: "duan_ngaythanhtoan",
          label: "Paid",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },

        // {
        //   key: "action",
        //   label: "",
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "25px !important", textAlign: "center" },
        // },
      ],
      local: {
        // monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
        //   "_"
        // ), // months of head
        // months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
        //   "_"
        // ), // months of panel
        // weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), // weeks,
      },

      customercontractid: 0,
      employeeModalShow: false,
      employee_name: "",
      project_name: "",
      projectItem: {
        id: 0,
        customercontractid: 0,
        employeeid: 0,
        employeecontractbonusid: 0,
        vaitrotrongduan: null,
        sotienthanhtoan: 0,
      },
      url: "/api/customercontract/pay",

      customercontractidlist: [],
      selected: [],

      //Hien thi mau bao cao
      reportModalShow: false,
      optionsReport: [],
      employee_list: [],
      not_sents: [],
      report: null,
      reportKind: null,

      fromDateReport3: new Date(new Date().getFullYear(), 0, 1),
      toDateReport3: new Date(new Date().getFullYear(), 0, 31),

      fromDateReport5: new Date(new Date().getFullYear(), 0, 1),
      toDateReport5: new Date(new Date().getFullYear(), 0, 31),

      fromDateReport6: new Date(new Date().getFullYear(), 0, 1),
      toDateReport6: new Date(new Date().getFullYear(), 0, 31),

      optionsKyBaoCao_Report3: [
        { value: 0, text: "Tháng 1" },
        { value: 1, text: "Tháng 2" },
        { value: 2, text: "Tháng 3" },
        { value: 3, text: "Tháng 4" },
        { value: 4, text: "Tháng 5" },
        { value: 5, text: "Tháng 6" },
        { value: 6, text: "Tháng 7" },
        { value: 7, text: "Tháng 8" },
        { value: 8, text: "Tháng 9" },
        { value: 9, text: "Tháng 10" },
        { value: 10, text: "Tháng 11" },
        { value: 11, text: "Tháng 12" },
        { value: 12, text: "Quý I" },
        { value: 13, text: "Quý II" },
        { value: 14, text: "Quý III" },
        { value: 15, text: "Quý IV" },
        { value: 16, text: "Năm" },
      ],
      kyBaoCao_Report3: 0,

      optionsKyBaoCao_Report5: [
        { value: 0, text: "Tháng 1" },
        { value: 1, text: "Tháng 2" },
        { value: 2, text: "Tháng 3" },
        { value: 3, text: "Tháng 4" },
        { value: 4, text: "Tháng 5" },
        { value: 5, text: "Tháng 6" },
        { value: 6, text: "Tháng 7" },
        { value: 7, text: "Tháng 8" },
        { value: 8, text: "Tháng 9" },
        { value: 9, text: "Tháng 10" },
        { value: 10, text: "Tháng 11" },
        { value: 11, text: "Tháng 12" },
        { value: 12, text: "Quý I" },
        { value: 13, text: "Quý II" },
        { value: 14, text: "Quý III" },
        { value: 15, text: "Quý IV" },
        { value: 16, text: "Năm" },
      ],
      kyBaoCao_Report5: 0,

      optionsKyBaoCao_Report6: [
        { value: 0, text: "January" },
        { value: 1, text: "February" },
        { value: 2, text: "March" },
        { value: 3, text: "April" },
        { value: 4, text: "May" },
        { value: 5, text: "June" },
        { value: 6, text: "July" },
        { value: 7, text: "August" },
        { value: 8, text: "September" },
        { value: 9, text: "October" },
        { value: 10, text: "November" },
        { value: 11, text: "December" },
        { value: 12, text: "Quarter I" },
        { value: 13, text: "Quarter II" },
        { value: 14, text: "Quarter III" },
        { value: 15, text: "Quarter IV" },
        { value: 16, text: "Yearling" },
      ],
      kyBaoCao_Report6: 0,

      employeeid_selected: 0,
      employees_selected: null,

      vitris_selected: null,

      old_row: null,
      openDetail: true,
      history: 0,
    };
  },
  computed: {
    project_bonus_read() {
      return this.$store.getters.hasPermission("project_bonus_read");
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = this_year; i >= 2020; i--) {
        result.push({ value: i, text: i });
      }
      return result;
    },
    project_report3() {
      return this.$store.getters.hasPermission("project_report3");
    },
    // project_report4() {
    //   return this.$store.getters.hasPermission("project_report4");
    // },
    project_report5() {
      return this.$store.getters.hasPermission("project_report5");
    },
    project_report6() {
      return this.$store.getters.hasPermission("project_report6");
    },
    project_report_all() {
      return this.$store.getters.hasPermission("project_report_all");
    },
    Employee_List() {
      var emp_list = this.employee_list.slice();
      for (var emp of emp_list) {
        emp.hovaten = emp.manhanvien + " - " + emp.hovaten;
      }
      emp_list.unshift({ id: null, hovaten: "" });

      return emp_list;
    },
    sum_total() {
      var sum = 0;
      for (var item of this.employees) {
        sum += item.sotienthanhtoan;
      }
      return sum;
    },
    sum_point() {
      let sum = 0;
      for (let item of this.employees) {
        sum += item.diem;
      }
      return sum;
    },
    // sum_revenue() {
    //   let sum = 0;
    //   for (let item of this.items) {sum += item.giatriduocnghiemthu;}
    //   return sum;
    // },
    sum_revenue() {
      let sum = 0;
      for (let item of this.items) {
        sum += item.duan_revenue;
      }
      return sum;
    },
    sum_cost() {
      let sum = 0;
      for (let item of this.items) {
        sum += item.chiphi;
      }
      return sum;
    },
    sum_profit() {
      return this.sum_revenue - this.sum_cost;
    },
    sum_bonus() {
      let sum = 0;
      for (let item of this.items) {
        sum += item.duan_bonus;
      }
      return sum;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get(`/api/customercontract/project`, { params: to.query }),
        //axios.get("/api/customercontract/project", { params: to.query }),
        axios.get("/api/department"),
        axios.get("/api/picklist?q=tinhtranghopdong"),
        axios.get("/api/picklist?q=tinhtranghoso"),
        axios.get("/api/picklist?q=vitricongviec"),
        axios.get("/api/picklist?q=vaitrotrongduan"),
        axios.get("/api/employeecontractbonus"),
        axios.get("/api/customercontract/notsendemail"),
        axios.get("/api/employee/getall"),
      ])
      .then(
        axios.spread(
          (
            customercontract,
            department,
            tinhtranghopdong,
            tinhtranghoso,
            vitricongviec,
            vaitrotrongduan,
            employeecontractbonus,
            not_sent,
            employee_list
          ) => {
            next((vm) =>
              vm.initData(
                customercontract.data,
                department.data,
                tinhtranghopdong.data,
                tinhtranghoso.data,
                vitricongviec.data,
                vaitrotrongduan.data,
                employeecontractbonus.data,
                not_sent.data,
                employee_list.data
              )
            );
          }
        )
      );
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/customercontract/project", { params: to.query })
      .then((response) => {
        this.items = response.data;
        this.init_selectCheckBox();
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  created() {
    // this.$toast.error("Length=" + window.history.length, "Error", { timeout: 3000 });
    // this.$toast.error("Current=" + this.$router.currentRoute.path, "Error", { timeout: 3000 });
    // if (window.history.length != this.history)
    // {
    //   this.year_selected = new Date().getFullYear();
    //   this.queryItem();
    //   this.history = window.history.length;
    // }
  },
  methods: {
    initData(
      customercontracts,
      departments,
      tinhtranghopdongs,
      tinhtranghosos,
      vitricongviecs,
      vaitrotrongduans,
      employeecontractbonuses,
      not_sents,
      employee_list
    ) {
      this.items = customercontracts;
      this.departments = departments;
      this.tinhtranghopdongs = tinhtranghopdongs;
      this.tinhtranghosos = tinhtranghosos;
      this.vitricongviecs = vitricongviecs;
      this.vaitrotrongduans = vaitrotrongduans;
      this.employeecontractbonuses = employeecontractbonuses;
      this.not_sents = not_sents;
      this.employee_list = employee_list;
      //Checkbox
      this.init_selectCheckBox(); //Gia tri TRUE cho cac ROW
      this.year_selected = new Date().getFullYear();
      this.month_selected = 0;
      this.status = 0;
      // this.year_selected = new Date().getFullYear();
      // this.month_selected = parseInt(new Date().getMonth() + 1); //Current month
    },
    addEmployeeToProject(data) {
      this.$router.push(`/project/${data.item.id}`);
    },
    deleteItem(data) {
      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/customercontract/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successful!", "Successful", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    findBonusPosition(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return this.findPickList(this.vitricongviecs, temp.vitricongviec);
    },
    findBonusMoney(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp.vnd == 0 ? temp.tien : temp.vnd;
    },
    findCurrency(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp.vnd == 0 ? "USD" : "VND";
    },
    findExchangeRate(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp.duan_quydoiusd == null ? "" : temp.duan_quydoiusd;
      //return temp.vnd == 0 ? "" : temp.duan_quydoiusd;
    },
    findExchangeRate2(list, id, list2, id2) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      // return temp.duan_quydoiusd == null ? "" : temp.duan_quydoiusd;
      return temp.vnd != 0 ? "" : this.findExchangeRate(list2, id2);
    },
    findPickList(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.madonvi;
    },

    onRowSelected(item) {
      this.selected = item;
      this.customercontractid = item[0].id;
      this.project_name = item[0].tieude;
      axios
        .get(`/api/customercontract/project/${this.customercontractid}`)
        .then((res) => {
          this.employees = res.data;
          this.selected = item;
        });
    },
    onRowClicked(row) {
      row._showDetails = !row._showDetails;

      if (this.old_row != null && this.old_row != row)
        this.old_row._showDetails = false;
      this.old_row = row;
      this.customercontractid = row.id;
      this.project_name = row.tieude;
      axios
        .get(`/api/customercontract/project/${this.customercontractid}`)
        .then((response) => {
          this.employees = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    openEmployeeModal(data) {
      this.employeeModalShow = true;
      axios
        .get(
          `/api/customercontract/project/${data.item.id}/${this.customercontractid}`
        )
        .then((res) => {
          this.id = res.data.id;
          this.customercontractid = res.data.customercontractid;
          this.employeeid = res.data.employeeid;
          this.employeecontractbonusid = res.data.id;
          this.vaitrotrongduan = res.data.vaitrotrongduan;
          this.sotienthanhtoan = res.data.sotienthanhtoan;

          this.employee_name = data.item.hovaten;
        });
    },

    closeEmployeeModal() {
      this.employeeModalShow = false;
      this.id = 0;
      this.customercontractid = 0;
      this.employeeid = 0;
      this.employeecontractbonusid = 0;
      this.vaitrotrongduan = null;
      this.sotienthanhtoan = 0;
    },

    openEmailModal(data) {
      //Chi lay nhung data duoc selectd
      //this.sendEmailItems = [];
      this.sendEmailItems = JSON.parse(JSON.stringify(data)); //data.slice(0);
      this.sendEmailItems = this.sendEmailItems.filter((item) => item.selected);
      //Check if no check
      if (this.sendEmailItems.length <= 0) {
        this.$toast.warning("Please select project!", "Warning", {
          timeout: 3000,
        });
        return;
      }
      if (this.year_selected == 0 || this.month_selected == 0) {
        this.$toast.warning(
          "Please select Year/Month to send mail!",
          "Warning",
          { timeout: 3000 }
        );
        return;
      }
      this.emailModalShow = true;
    },

    closeEmailModal() {
      this.emailModalShow = false;
      this.sendEmailItems = [];
      // this.userName = null;
      // this.password = null;
    },

    closePayModal() {
      this.payModalShow = false;
      this.payItems = [];
      this.pay_ngaythanhtoan = null;
    },

    openPayModal(data) {
      //Chi lay nhung data duoc selectd
      //this.sendEmailItems = [];
      this.payItems = JSON.parse(JSON.stringify(data)); //data.slice(0);
      this.payItems = this.payItems.filter((item) => item.selected);
      if (this.payItems.length <= 0) {
        this.$toast.warning("Please select project!", "Warning", {
          timeout: 3000,
        });
        return;
      }
      this.payModalShow = true;
    },

    openReportModal() {
      //Kiem tra chon Nam de xem bao cao
      if (this.year_selected <= 0) {
        this.$toast.warning("Please select YEAR of report!", "Warning", {
          timeout: 3000,
        });
        return;
      }
      this.kyBaoCao_Report3 = 0;
      (this.fromDateReport3 = new Date(this.year_selected, 0, 1)), // Set ngay thang 1 theo nam da chon
        (this.toDateReport3 = new Date(this.year_selected, 0, 31)),
        (this.kyBaoCao_Report5 = 0);
      (this.fromDateReport5 = new Date(this.year_selected, 0, 1)),
        (this.toDateReport5 = new Date(this.year_selected, 0, 31)),
        (this.kyBaoCao_Report6 = 0);
      (this.fromDateReport6 = new Date(this.year_selected, 0, 1)),
        (this.toDateReport6 = new Date(this.year_selected, 0, 31)),
        (this.reportModalShow = true);
      this.report = null;
    },

    closeReportModal() {
      this.reportModalShow = false;
      this.reportKind = null;
      this.employees_selected = null;
      this.kyBaoCao_Report3 = 0;
    },

    sendEmailToProject(data) {
      var reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!(this.email && this.email.length) || !this.password.length) {
        this.$toast.error("Please enter full information!", "Error", {
          timeout: 3000,
        });
        return;
      }
      if (!reg_email.test(this.email)) {
        this.$toast.error("Email format is incorrect!", "Error", {
          timeout: 3000,
        });
        return;
      }

      var found_not_lock = data.find((x) => x.duan_lock == 0);
      if (typeof found_not_lock != "undefined") {
        this.$toast.error("There is an unlocked project!", "Error", {
          timeout: 3000,
        });
        return;
      }

      this.isLoading = true;

      const formData = new FormData();
      formData.append("username", this.email);
      formData.append("password", this.password);
      formData.append("monthrange", this.month_selected);
      formData.append("year", this.year_selected);

      for (var i = 0; i < data.length; i++) {
        formData.append("customercontractidlist", data[i].id);
      }

      axios
        .post("/api/customercontract/send", formData)
        .then(() => {
          this.$toast.success("Email is sent!", "Success", { timeout: 3000 });
          // this.items = res.data;
          axios
            .get("/api/customercontract/notsendemail")
            .then((res) => (this.not_sents = res.data));
          this.isLoading = false;
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.isLoading = false;
        });
      // this.$toast.success("Email is sent" , "Success", {timeout: 3000,});
      //this.isLoading = false;
    },

    payProject(data) {
      if (this.pay_ngaythanhtoan == "") {
        this.$toast.error("Enter payment date!", "Error", { timeout: 3000 });
        return;
      }

      for (var itr of data) {
        if (!this.check_if_sent(itr.id)) {
          this.$toast.error(
            "Project[" + itr.tieude + "] hasn't sent all staff emails yet!",
            "Error",
            { timeout: 3000 }
          );
          return;
        }
      }

      this.pay_ngaythanhtoan = this.$convert_string_date(
        this.pay_ngaythanhtoan
      );
      for (var i in data) {
        data[i].duan_ngaythanhtoan = this.pay_ngaythanhtoan;
      }

      axios
        //Chi update truong chi phi
        //.put("/api/customercontract", this.item)
        .patch(this.url, data)
        .then((res) => {
          this.$toast.success("Project is paid!", "Success", { timeout: 3000 });
          for (var i in this.items) {
            for (var j in res.data) {
              if (this.items[i].id == res.data[j].id) {
                this.items[i].duan_ngaythanhtoan =
                  res.data[j].duan_ngaythanhtoan;
                break;
              }
            }
          }
          this.closePayModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    updateEmployeeProject() {},

    selectCheckBoxHeader(data) {
      this.$toast.error(data, "Error", {
        timeout: 3000,
      });
    },

    init_selectCheckBox() {
      for (let i = 0; i < this.items.length; i++) {
        let newValue = Object.assign({}, this.items[i], { selected: false });
        this.$set(this.items, i, newValue);
      }
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = this.year_selected;
      query.month = this.month_selected;
      query.day = this.day_selected;
      query.status = this.status_selected;
      this.item = null;
      this.$router.push({ query: query });
      // axios.get("/api/customercontract/project", {params: query})
      // .then((res) => {
      //   this.items = res.data;
      //   this.init_selectCheckBox();
      // });

      //Thay doi mau cua trangthai
      var optionElement = document.getElementById("rgb");
      if (this.tinhtrang == 0) optionElement.style.background = "#FFEEFD";
      else if (this.tinhtrang == 1) optionElement.style.background = "#FFE1C6";
      else if (this.tinhtrang == 2) optionElement.style.background = "#FFFFD7";
      else if (this.tinhtrang == 3) optionElement.style.background = "#E2FCE6";
      else if (this.tinhtrang == 4) optionElement.style.background = "#C0F7FE";
    },

    //ReportModal
    changeReportKind() {
      if (this.reportKind == 3 && this.employees.length <= 0) {
        axios
          .get("/api/employee/getall")
          .then((response) => {
            this.employees = response.data;
            this.employees.unshift({ mahovaten: "Tất cả", id: 0 });
          })
          .catch((err) => {});
      }
    },
    check_if_sent(id) {
      var found = this.not_sents.find((x) => x.customercontractid == id);
      if (typeof found == "undefined") return true;
      return false;
    },
    changeKyBaoCao_Report3() {
      //0.Thang 1
      if (this.kyBaoCao_Report3 == 0) {
        this.fromDateReport3 = new Date(this.year_selected, 0, 1);
        this.toDateReport3 = new Date(this.year_selected, 0, 31);
      }
      //1.Thang 2
      else if (this.kyBaoCao_Report3 == 1) {
        this.fromDateReport3 = new Date(this.year_selected, 1, 1);
        this.toDateReport3 = new Date(this.year_selected, 2, 0);
      }
      //2.Thang 3
      else if (this.kyBaoCao_Report3 == 2) {
        this.fromDateReport3 = new Date(this.year_selected, 2, 1);
        this.toDateReport3 = new Date(this.year_selected, 2, 31);
      }
      //3.Thang 4
      else if (this.kyBaoCao_Report3 == 3) {
        this.fromDateReport3 = new Date(this.year_selected, 3, 1);
        this.toDateReport3 = new Date(this.year_selected, 3, 30);
      }
      //4.Thang 5
      else if (this.kyBaoCao_Report3 == 4) {
        this.fromDateReport3 = new Date(this.year_selected, 4, 1);
        this.toDateReport3 = new Date(this.year_selected, 4, 31);
      }
      //5.Thang 6
      else if (this.kyBaoCao_Report3 == 5) {
        this.fromDateReport3 = new Date(this.year_selected, 5, 1);
        this.toDateReport3 = new Date(this.year_selected, 5, 30);
      }
      //6.Thang 7
      else if (this.kyBaoCao_Report3 == 6) {
        this.fromDateReport3 = new Date(this.year_selected, 6, 1);
        this.toDateReport3 = new Date(this.year_selected, 6, 31);
      }
      //7.Thang 8
      else if (this.kyBaoCao_Report3 == 7) {
        this.fromDateReport3 = new Date(this.year_selected, 7, 1);
        this.toDateReport3 = new Date(this.year_selected, 7, 31);
      }
      //8.Thang 9
      else if (this.kyBaoCao_Report3 == 8) {
        this.fromDateReport3 = new Date(this.year_selected, 8, 1);
        this.toDateReport3 = new Date(this.year_selected, 8, 30);
      }
      //9.Thang 10
      else if (this.kyBaoCao_Report3 == 9) {
        this.fromDateReport3 = new Date(this.year_selected, 9, 1);
        this.toDateReport3 = new Date(this.year_selected, 9, 31);
      }
      //10.Thang 11
      else if (this.kyBaoCao_Report3 == 10) {
        this.fromDateReport3 = new Date(this.year_selected, 10, 1);
        this.toDateReport3 = new Date(this.year_selected, 10, 30);
      }
      //11.Thang 12
      else if (this.kyBaoCao_Report3 == 11) {
        this.fromDateReport3 = new Date(this.year_selected, 11, 1);
        this.toDateReport3 = new Date(this.year_selected, 11, 31);
      }
      //12.Quy I
      else if (this.kyBaoCao_Report3 == 12) {
        this.fromDateReport3 = new Date(this.year_selected, 0, 1);
        this.toDateReport3 = new Date(this.year_selected, 2, 31);
      }
      //13.Quy II
      else if (this.kyBaoCao_Report3 == 13) {
        this.fromDateReport3 = new Date(this.year_selected, 3, 1);
        this.toDateReport3 = new Date(this.year_selected, 5, 30);
      }
      //14.Quy III
      else if (this.kyBaoCao_Report3 == 14) {
        this.fromDateReport3 = new Date(this.year_selected, 6, 1);
        this.toDateReport3 = new Date(this.year_selected, 8, 30);
      }
      //15.Quy IV
      else if (this.kyBaoCao_Report3 == 15) {
        this.fromDateReport3 = new Date(this.year_selected, 9, 1);
        this.toDateReport3 = new Date(this.year_selected, 11, 31);
      }
      //16.Nam
      else if (this.kyBaoCao_Report3 == 16) {
        this.fromDateReport3 = new Date(this.year_selected, 0, 1);
        this.toDateReport3 = new Date(this.year_selected, 11, 31);
      }
    },

    changeKyBaoCao_Report5() {
      //0.Thang 1
      if (this.kyBaoCao_Report5 == 0) {
        this.fromDateReport5 = new Date(this.year_selected, 0, 1);
        this.toDateReport5 = new Date(this.year_selected, 0, 31);
      }
      //1.Thang 2
      else if (this.kyBaoCao_Report5 == 1) {
        this.fromDateReport5 = new Date(this.year_selected, 1, 1);
        this.toDateReport5 = new Date(this.year_selected, 2, 0);
      }
      //2.Thang 3
      else if (this.kyBaoCao_Report5 == 2) {
        this.fromDateReport5 = new Date(this.year_selected, 2, 1);
        this.toDateReport5 = new Date(this.year_selected, 2, 31);
      }
      //3.Thang 4
      else if (this.kyBaoCao_Report5 == 3) {
        this.fromDateReport5 = new Date(this.year_selected, 3, 1);
        this.toDateReport5 = new Date(this.year_selected, 3, 30);
      }
      //4.Thang 5
      else if (this.kyBaoCao_Report5 == 4) {
        this.fromDateReport5 = new Date(this.year_selected, 4, 1);
        this.toDateReport5 = new Date(this.year_selected, 4, 31);
      }
      //5.Thang 6
      else if (this.kyBaoCao_Report5 == 5) {
        this.fromDateReport5 = new Date(this.year_selected, 5, 1);
        this.toDateReport5 = new Date(this.year_selected, 5, 30);
      }
      //6.Thang 7
      else if (this.kyBaoCao_Report5 == 6) {
        this.fromDateReport5 = new Date(this.year_selected, 6, 1);
        this.toDateReport5 = new Date(this.year_selected, 6, 31);
      }
      //7.Thang 8
      else if (this.kyBaoCao_Report5 == 7) {
        this.fromDateReport5 = new Date(this.year_selected, 7, 1);
        this.toDateReport5 = new Date(this.year_selected, 7, 31);
      }
      //8.Thang 9
      else if (this.kyBaoCao_Report5 == 8) {
        this.fromDateReport5 = new Date(this.year_selected, 8, 1);
        this.toDateReport5 = new Date(this.year_selected, 8, 30);
      }
      //9.Thang 10
      else if (this.kyBaoCao_Report5 == 9) {
        this.fromDateReport5 = new Date(this.year_selected, 9, 1);
        this.toDateReport5 = new Date(this.year_selected, 9, 31);
      }
      //10.Thang 11
      else if (this.kyBaoCao_Report5 == 10) {
        this.fromDateReport5 = new Date(this.year_selected, 10, 1);
        this.toDateReport5 = new Date(this.year_selected, 10, 30);
      }
      //11.Thang 12
      else if (this.kyBaoCao_Report5 == 11) {
        this.fromDateReport5 = new Date(this.year_selected, 11, 1);
        this.toDateReport5 = new Date(this.year_selected, 11, 31);
      }
      //12.Quy I
      else if (this.kyBaoCao_Report5 == 12) {
        this.fromDateReport5 = new Date(this.year_selected, 0, 1);
        this.toDateReport5 = new Date(this.year_selected, 2, 31);
      }
      //13.Quy II
      else if (this.kyBaoCao_Report5 == 13) {
        this.fromDateReport5 = new Date(this.year_selected, 3, 1);
        this.toDateReport5 = new Date(this.year_selected, 5, 30);
      }
      //14.Quy III
      else if (this.kyBaoCao_Report5 == 14) {
        this.fromDateReport5 = new Date(this.year_selected, 6, 1);
        this.toDateReport5 = new Date(this.year_selected, 8, 30);
      }
      //15.Quy IV
      else if (this.kyBaoCao_Report5 == 15) {
        this.fromDateReport5 = new Date(this.year_selected, 9, 1);
        this.toDateReport5 = new Date(this.year_selected, 11, 31);
      }
      //16.Nam
      else if (this.kyBaoCao_Report5 == 16) {
        this.fromDateReport5 = new Date(this.year_selected, 0, 1);
        this.toDateReport5 = new Date(this.year_selected, 11, 31);
      }
    },

    changeKyBaoCao_Report6() {
      //0.Thang 1
      if (this.kyBaoCao_Report6 == 0) {
        this.fromDateReport6 = new Date(this.year_selected, 0, 1);
        this.toDateReport6 = new Date(this.year_selected, 0, 31);
      }
      //1.Thang 2
      else if (this.kyBaoCao_Report6 == 1) {
        this.fromDateReport6 = new Date(this.year_selected, 1, 1);
        this.toDateReport6 = new Date(this.year_selected, 2, 0);
      }
      //2.Thang 3
      else if (this.kyBaoCao_Report6 == 2) {
        this.fromDateReport6 = new Date(this.year_selected, 2, 1);
        this.toDateReport6 = new Date(this.year_selected, 2, 31);
      }
      //3.Thang 4
      else if (this.kyBaoCao_Report6 == 3) {
        this.fromDateReport6 = new Date(this.year_selected, 3, 1);
        this.toDateReport6 = new Date(this.year_selected, 3, 30);
      }
      //4.Thang 5
      else if (this.kyBaoCao_Report6 == 4) {
        this.fromDateReport6 = new Date(this.year_selected, 4, 1);
        this.toDateReport6 = new Date(this.year_selected, 4, 31);
      }
      //5.Thang 6
      else if (this.kyBaoCao_Report6 == 5) {
        this.fromDateReport6 = new Date(this.year_selected, 5, 1);
        this.toDateReport6 = new Date(this.year_selected, 5, 30);
      }
      //6.Thang 7
      else if (this.kyBaoCao_Report6 == 6) {
        this.fromDateReport6 = new Date(this.year_selected, 6, 1);
        this.toDateReport6 = new Date(this.year_selected, 6, 31);
      }
      //7.Thang 8
      else if (this.kyBaoCao_Report6 == 7) {
        this.fromDateReport6 = new Date(this.year_selected, 7, 1);
        this.toDateReport6 = new Date(this.year_selected, 7, 31);
      }
      //8.Thang 9
      else if (this.kyBaoCao_Report6 == 8) {
        this.fromDateReport6 = new Date(this.year_selected, 8, 1);
        this.toDateReport6 = new Date(this.year_selected, 8, 30);
      }
      //9.Thang 10
      else if (this.kyBaoCao_Report6 == 9) {
        this.fromDateReport6 = new Date(this.year_selected, 9, 1);
        this.toDateReport6 = new Date(this.year_selected, 9, 31);
      }
      //10.Thang 11
      else if (this.kyBaoCao_Report6 == 10) {
        this.fromDateReport6 = new Date(this.year_selected, 10, 1);
        this.toDateReport6 = new Date(this.year_selected, 10, 30);
      }
      //11.Thang 12
      else if (this.kyBaoCao_Report6 == 11) {
        this.fromDateReport6 = new Date(this.year_selected, 11, 1);
        this.toDateReport6 = new Date(this.year_selected, 11, 31);
      }
      //12.Quy I
      else if (this.kyBaoCao_Report6 == 12) {
        this.fromDateReport6 = new Date(this.year_selected, 0, 1);
        this.toDateReport6 = new Date(this.year_selected, 2, 31);
      }
      //13.Quy II
      else if (this.kyBaoCao_Report6 == 13) {
        this.fromDateReport6 = new Date(this.year_selected, 3, 1);
        this.toDateReport6 = new Date(this.year_selected, 5, 30);
      }
      //14.Quy III
      else if (this.kyBaoCao_Report6 == 14) {
        this.fromDateReport6 = new Date(this.year_selected, 6, 1);
        this.toDateReport6 = new Date(this.year_selected, 8, 30);
      }
      //15.Quy IV
      else if (this.kyBaoCao_Report6 == 15) {
        this.fromDateReport6 = new Date(this.year_selected, 9, 1);
        this.toDateReport6 = new Date(this.year_selected, 11, 31);
      }
      //16.Nam
      else if (this.kyBaoCao_Report6 == 16) {
        this.fromDateReport6 = new Date(this.year_selected, 0, 1);
        this.toDateReport6 = new Date(this.year_selected, 11, 31);
      }
    },

    exportExcel() {
      if (this.reportKind == null) return;
      if (this.reportKind == 3) {
        const formData = new FormData();
        formData.append(
          "from",
          this.fromDateReport3 == null
            ? ""
            : new Date(this.fromDateReport3).toUTCString()
        );
        formData.append(
          "to",
          this.toDateReport3 == null
            ? ""
            : new Date(this.toDateReport3).toUTCString()
        );

        if (this.employees_selected != null) {
          for (var employee of this.employees_selected) {
            formData.append("employeelist", employee.id);
          }
        } else formData.append("employeelist", -1);

        axios
          .post("/api/customercontractreport/project", formData, {
            responseType: "blob",
          })
          .then((res) => {
            this.downloadExcelFile(res);
            this.closeReportModal();
          })
          .catch((err) => {});
      }
      if (this.reportKind == 5 && this.note_employee == false) {
        let query = Object.assign({}, this.$route.query);
        query.report = 5;
        query.fromdate = this.fromDateReport5;
        query.todate = this.toDateReport5;
        //query.range = this.kyBaoCao_Report5;
        query.range = this.optionsKyBaoCao_Report5[this.kyBaoCao_Report5].text;

        axios({
          method: "get",
          url: `/api/CustomerContractReport/report`,
          params: query,
          responseType: "blob", // important
        })
          .then((res) => {
            this.downloadExcelFile(res);
            this.closeReportModal();
          })
          .catch((err) => {});
      }
      if (this.reportKind == 5 && this.note_employee == true) {
        let query = Object.assign({}, this.$route.query);
        query.report = 7;
        query.fromdate = this.fromDateReport5;
        query.todate = this.toDateReport5;
        //query.range = this.kyBaoCao_Report5;
        query.range = this.optionsKyBaoCao_Report5[this.kyBaoCao_Report5].text;

        axios({
          method: "get",
          url: `/api/CustomerContractReport/report`,
          params: query,
          responseType: "blob", // important
        })
          .then((res) => {
            this.downloadExcelFile(res);
            this.closeReportModal();
          })
          .catch((err) => {});
      }
      if (this.reportKind == 6) {
        let query = Object.assign({}, this.$route.query);
        query.report = 6;
        query.fromdate = this.fromDateReport6;
        query.todate = this.toDateReport6;
        //query.range = this.kyBaoCao_Report5;
        query.range = this.optionsKyBaoCao_Report6[this.kyBaoCao_Report6].text;
        axios({
          method: "get",
          url: `/api/CustomerContractReport/report`,
          params: query,
          responseType: "blob", // important
        })
          .then((res) => {
            this.downloadExcelFile(res);
            this.closeReportModal();
          })
          .catch((err) => {});
      }
    },
    downloadExcelFile(res) {
      let filename = res.headers["content-disposition"]
        .split(";")
        .find(function(el) {
          if (el.includes("filename=")) return el;
        })
        .replace("filename=", "")
        .trim();
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    filterEmployee() {
      var input_string = "/api/customercontract/project/filter_for_position?";

      if (this.vitris_selected != null) {
        for (var vitri of this.vitris_selected) {
          input_string += "positions=" + vitri.id + "&";
        }
        input_string = input_string.substr(0, input_string.length - 1);
      }

      axios
        .get(input_string)
        .then((res) => {
          this.employee_list = res.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 10000 });
        });
    },
  },
  watch: {
    selectAll: function(newValue, oldValue) {
      if (newValue) {
        for (let i = 0; i < this.items.length; i++) {
          let newObj = Object.assign({}, this.items[i], { selected: true });
          this.$set(this.items, i, newObj);
        }
      } else {
        for (let i = 0; i < this.items.length; i++) {
          let newObj = Object.assign({}, this.items[i], { selected: false });
          this.$set(this.items, i, newObj);
        }
      }
    },
  },
};
</script>
<style scoped>
option {
  background: #fff;
}
.badge {
  /* padding: 1px 9px 2px; */
  font-size: 13.025px;
  font-weight: bold;
  white-space: nowrap;
  background-color: #999999;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.badge-success {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-success:hover {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-primary {
  color: #383838;
  background-color: #ffffd7;
}
.badge-primary:hover {
  color: #383838;
  background-color: #ffffd7;
}

.badge-info {
  color: #383838;
  background-color: #ffe1c6;
}
.badge-info:hover {
  color: #383838;
  background-color: #ffe1c6;
}

.badge-warning {
  color: #ffffff;
  background-color: #fc8b28;
}
.badge-warning:hover {
  color: #ffffff;
  background-color: #fc8b28;
}

.badge-danger {
  color: #ffffff;
  background-color: #df515f;
}
.badge-danger:hover {
  color: #ffffff;
  background-color: #df515f;
}

.badge-danger2 {
  color: #ffffff;
  background-color: #c55e97;
}
.badge-danger2:hover {
  color: #ffffff;
  background-color: #c55e97;
}
</style>
